export const PRIVACY_POLICY_LINK = "/privacy";
export const TERMS_LINK = "/terms";
export const FEEDBACK_LINK = "https://forms.gle/Tc4U3x1xmLy7cpcF6";
export const CONTACT_LINK =
  "mailto:oleary.gabe@gmail.com?subject=Reconcile%20Contact";
